import PropTypes from 'prop-types';

const FAQItemProptypes = {
  id: PropTypes.string,
  question: PropTypes.string,
  answerRichText: PropTypes.shape({
    raw: PropTypes.string,
    references: PropTypes.arrayOf(PropTypes.shape({
      contentful_id: PropTypes.string,
      microtext: PropTypes.shape({
        body: PropTypes.string,
      }),
    })),
  }),
};

export default FAQItemProptypes;
